import { Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import usePut from '../../../../../hooks/usePut';
import { CLINIC_FEEDBACKS_LIST, MARK_ALL_READ, USER_FEEDBACKS_LIST } from '../../../../../enums/ApiPaths';
import { buildFeedbackQueryKey } from '../hooks/useGetFeedbacks';
import { useSearchParams } from 'react-router-dom';

export default function MarkAllAsRead() {
    const {t} = useTranslation();
    const [searchParams] = useSearchParams();
    
    const clinics = buildFeedbackQueryKey(CLINIC_FEEDBACKS_LIST, searchParams);
    const users = buildFeedbackQueryKey(USER_FEEDBACKS_LIST, searchParams);

    const post = usePut(MARK_ALL_READ, "mark_as_read", [clinics, users])

    async function handleMarkAllAsRead() {
        await post.submitCallback()
    }


  return (
    <Button variant='outlined' color='warning' onClick={()=>handleMarkAllAsRead()}>
        {t("MarkAllAsRead")}
    </Button>
  )
}
